export const merchandising_columns = [
  {
    title: 'Location number',
    dataIndex: 'locationNumber',
    key: 'action',
    width: 120,
    fixed: 'left',
  },
  {
    title: 'Location name',
    dataIndex: 'locationName',
    key: 'locationName',
    width: 250,
  },
  {
    title: 'Merchandising Tier',
    dataIndex: 'merchandisingTier',
    key: 'merchandisingTier',
    width: 180,
  },
];
